import {onChangeCheckedHandler} from 'lib/dom'
import Switch from 'lib/ui/form/Switch'
import React from 'react'
import styled from 'styled-components'

export default function ShowArchivedButton(props: {
  showArchived: boolean
  onChange: (archived: boolean) => void
}) {
  return (
    <StyledSwitch
      label="Archived"
      checked={props.showArchived}
      onChange={onChangeCheckedHandler(props.onChange)}
      labelPlacement="end"
      aria-label="show archived events"
    />
  )
}

const StyledSwitch = styled(Switch)`
  margin-bottom: 0;
  padding-left: 0;
  & > label {
    align-items: center;
    margin-bottom: 0;
  }
`
